import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { CommunityCycling } from 'images/latest'

const CommunityCyclingIcon = ({ color = 'black' }) => (
  <ResponsiveSVG
    width='46px'
    height='33px'
    className='unstyled'
    fill={color}
    SVG={CommunityCycling}
  />
)

export default CommunityCyclingIcon
